import { Info } from 'components/icons';
import { Alert, AlertDescription, AlertTitle } from 'components/ui/alert';
import { useInvoice } from 'pages/invoices/hooks/useInvoice';
import { FormattedMessage } from 'react-intl';
import { InvoiceData } from 'types/invoices';

/**
 * At the top of a tab's column, what a credit note or a correction invoice is to the invoice it comes from and what
 * that means for its rows. The classic page says it with its tinted tabs; nothing here waits for the user.
 */
export function InvoiceVariantNotice({ invoice }: { invoice: InvoiceData }) {
    const { isCredit, isCorrection } = useInvoice(invoice);
    // A correction's origin is the invoice its Originates from row names, which many have with no debit link.
    const origin = ((isCorrection && invoice.originatesFromInvoice) || invoice.debitInvoice)?.invoiceNumber;
    if (!origin || !(isCredit || isCorrection)) {
        return null;
    }
    const key = isCredit ? 'credit-note' : 'correction';
    return (
        <Alert
            role="note"
            className={
                isCredit
                    ? 'bg-primary-tint text-foreground border-transparent'
                    : 'border-changed-border bg-changed text-changed-ink'
            }
        >
            <Info aria-hidden />
            <AlertTitle>
                <FormattedMessage id={`invoices.notices.${key}-title`} values={{ invoice: origin }} />
            </AlertTitle>
            <AlertDescription className="text-current">
                <FormattedMessage id={`invoices.notices.${key}-text`} />
            </AlertDescription>
        </Alert>
    );
}
